import React from "react"
import PropTypes from "prop-types"

const Vd = ({ width, height, fillColor }) => (
  <svg
    id="Calque_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 105"
    width={width}
    height={height}
  >
    <path
      fill={fillColor}
      d="M6.67,66.86c.41,.13,.97,.2,1.66,.2s1.23-.07,1.65-.2c1.06-.34,1.67-1.21,1.67-2.4,0-.91-.4-1.68-1.08-2.07l-.25-.06c-.22,0-.39,.17-.39,.39,0,.16,.08,.28,.23,.38,.45,.32,.66,.76,.66,1.37,0,.79-.39,1.34-1.11,1.57-.36,.12-.75,.16-1.38,.16s-1.03-.05-1.39-.17c-.73-.23-1.11-.77-1.11-1.56,0-.61,.21-1.05,.66-1.36,.15-.1,.23-.23,.23-.39,0-.22-.17-.39-.39-.39l-.25,.06c-.68,.39-1.08,1.17-1.08,2.08,0,1.18,.61,2.06,1.67,2.4Z"
    />
    <path
      fill={fillColor}
      d="M9.72,61.71c1.16,0,1.92-.86,1.92-2.2,0-.88-.23-1.48-.77-1.99l.43-.26c.17-.1,.26-.23,.26-.4,0-.26-.17-.44-.41-.44l-.23,.06-.47,.25c-.17,.08-.28,.12-.63,.12h-2.52c-1.57,0-2.29,.74-2.29,2.34,0,.77,.2,1.49,.54,1.94l.34,.17c.24,0,.4-.16,.4-.4l-.09-.29c-.18-.31-.38-.84-.38-1.39,0-1.1,.44-1.55,1.54-1.55h.45v1.6c0,1.57,.69,2.44,1.93,2.44Zm-1.14-4.04h.93c.81,0,1.31,.66,1.31,1.72,0,.67-.19,1.47-1.1,1.47-.8,0-1.14-.51-1.14-1.69v-1.5Z"
    />
    <path
      fill={fillColor}
      d="M5.53,54.44c-.28,0-.45,.16-.45,.43s.17,.43,.45,.43h5.58c.28,0,.45-.17,.45-.43s-.17-.43-.45-.43h-3.62c-.98,0-1.67-.67-1.67-1.63,0-1.05,.59-1.56,1.8-1.56h3.49c.28,0,.45-.16,.45-.43s-.17-.43-.45-.43h-3.66c-1.53,0-2.45,.84-2.45,2.25,0,.78,.26,1.39,.76,1.79h-.22Z"
    />
    <path
      fill={fillColor}
      d="M5.13,49.2c0,.25,.15,.41,.39,.41s.39-.16,.39-.41v-.51h3.9c1.26,0,1.75-.47,1.75-1.67v-.17c0-.26-.16-.44-.41-.44s-.41,.18-.41,.44c0,.78-.2,.99-.95,.99h-3.88v-1c0-.25-.15-.42-.39-.42s-.39,.16-.39,.42v1h-1.6c-.28,0-.45,.16-.45,.42s.17,.43,.45,.43h1.6v.51Z"
    />
    <path
      fill={fillColor}
      d="M9.97,40.86c-.49-.15-.96-.21-1.66-.21s-1.16,.06-1.65,.21c-1.06,.35-1.67,1.23-1.67,2.41s.61,2.05,1.67,2.4c.48,.15,.96,.21,1.65,.21s1.17-.06,1.66-.21c1.06-.35,1.67-1.22,1.67-2.4s-.61-2.06-1.67-2.41Zm-.27,3.99c-.36,.12-.75,.17-1.39,.17s-1.02-.04-1.38-.17c-.71-.24-1.11-.81-1.11-1.58s.4-1.35,1.11-1.59c.36-.12,.75-.16,1.38-.16s1.03,.05,1.39,.16c.72,.24,1.11,.81,1.11,1.59s-.41,1.34-1.11,1.58Z"
    />
    <path
      fill={fillColor}
      d="M15.42,64.92c-.41,.15-.75,.45-.75,.98,0,.67,.49,1.01,.98,1.01,.19,0,.34-.03,.57-.11l15.42-5.93c.94-.34,1.24-.67,1.24-1.31s-.3-.98-1.24-1.31l-15.42-5.93c-.23-.08-.38-.11-.57-.11-.49,0-.98,.34-.98,1.01,0,.53,.34,.83,.75,.98l14.11,5.29v.04l-14.11,5.4Z"
    />
    <path
      fill={fillColor}
      d="M32.57,69.9H5.68c-.25,0-.45,.2-.46,.45,0,.01-.03,1.3,0,3.18,.04,1.72,.16,4.32,.49,6.89,.12,.99,.31,1.97,.55,2.98h0l.15,.58c.6,2.31,1.51,4.58,2.69,6.74,1.65,3.02,3.88,5.96,6.82,9.01,.18,.19,.35,.37,.52,.55,.5,.53,.93,.98,1.3,1.32,.57,.54,.99,.78,1.39,.81h.06c.4-.03,.79-.26,1.37-.81,.31-.29,.66-.66,1.07-1.08,.23-.24,.48-.5,.76-.79,2.93-3.07,5.16-6.02,6.8-9.01,1.19-2.17,2.1-4.44,2.7-6.74l.15-.58h-.01c.24-1,.43-2,.55-2.98,.25-2.04,.4-4.36,.46-6.89,.04-1.88,0-3.17,0-3.18,0-.25-.21-.45-.46-.45Zm-14.22,31.03c-.35-.32-.77-.77-1.26-1.28-.17-.17-.34-.36-.52-.55-2.88-2.99-5.06-5.87-6.67-8.82-.68-1.23-1.26-2.5-1.74-3.79l10.87,14.96c-.13-.06-.34-.2-.68-.52Zm1.56,0l-.33,.29-12.03-16.55-.1-.35h1.54l11.58,15.94c-.24,.25-.47,.48-.67,.67Zm1.8-1.84c-.27,.27-.5,.52-.73,.75l-11.28-15.52h1.69l10.55,14.52-.23,.25Zm.63-.68l-10.24-14.1h1.69l9.49,13.06c-.3,.35-.62,.69-.93,1.04Zm1.32-1.48l-9.17-12.61h1.69l8.38,11.54c-.29,.36-.59,.72-.91,1.08Zm1.28-1.54l-8.04-11.07h1.69l7.22,9.93c-.28,.38-.57,.75-.86,1.14Zm1.22-1.63l-6.87-9.44h1.69l5.99,8.25c-.26,.4-.53,.8-.82,1.19Zm1.15-1.71l-5.61-7.73h1.69l4.69,6.46c-.24,.43-.5,.85-.76,1.27Zm1.07-1.83l-4.29-5.9h1.69l3.3,4.54c-.22,.46-.45,.91-.7,1.36Zm.98-1.96l-2.87-3.95h1.69l1.8,2.48c-.19,.5-.4,.99-.62,1.47Zm.86-2.12l-1.33-1.83h1.93c-.18,.61-.38,1.22-.6,1.83Zm1.87-12.64c-.05,2.5-.21,4.79-.45,6.8-.13,1.01-.33,2.05-.58,3.09H7.21c-.26-1.05-.45-2.07-.58-3.1-.32-2.53-.44-5.09-.48-6.79-.03-1.2-.02-2.16-.02-2.69h25.99c0,.53,.01,1.48-.01,2.69Z"
    />
    <polygon
      fill={fillColor}
      points="12.75 75.42 12.57 75.24 11.32 75.24 11.29 75.22 11.29 72.9 11.1 72.7 10.92 72.9 10.92 75.41 11.1 75.59 12.57 75.59 12.75 75.42"
    />
    <polygon
      fill={fillColor}
      points="13.82 75.41 13.82 72.9 13.63 72.7 13.44 72.9 13.44 75.41 13.63 75.62 13.82 75.41"
    />
    <path
      fill={fillColor}
      d="M15.83,75.59c.58,0,.93-.28,.93-.82,0-.38-.23-.61-.44-.66h0c.24-.1,.39-.3,.39-.64,0-.46-.29-.75-.86-.75h-.89l-.17,.17v2.53l.17,.17h.88Zm-.67-2.5l.02-.03h.65c.32,0,.5,.18,.5,.45s-.18,.45-.5,.45h-.65l-.02-.02v-.85Zm0,1.24l.02-.03h.67c.34,0,.53,.19,.53,.47s-.19,.47-.53,.47h-.67l-.02-.02v-.9Z"
    />
    <polygon
      fill={fillColor}
      points="19.23 75.24 17.98 75.24 17.96 75.22 17.96 74.34 17.98 74.32 19.02 74.32 19.21 74.14 19.02 73.97 17.98 73.97 17.96 73.94 17.96 73.1 17.98 73.07 19.23 73.07 19.42 72.9 19.23 72.72 17.75 72.72 17.58 72.89 17.58 75.43 17.75 75.59 19.23 75.59 19.42 75.42 19.23 75.24"
    />
    <path
      fill={fillColor}
      d="M22.19,73.55c0-.51-.35-.83-.91-.83h-.9l-.17,.17v2.52l.19,.2,.18-.2v-1.01l.02-.03h.64l.57,1.12,.18,.12,.18-.18-.03-.1-.52-1.01c.34-.11,.55-.39,.55-.77Zm-.91,.47h-.67l-.02-.03v-.9l.02-.03h.67c.34,0,.53,.18,.53,.48s-.2,.47-.53,.47Z"
    />
    <polygon
      fill={fillColor}
      points="24.89 72.9 24.71 72.72 22.96 72.72 22.77 72.9 22.96 73.07 23.62 73.07 23.64 73.1 23.64 75.41 23.83 75.61 24.02 75.41 24.02 73.1 24.04 73.07 24.71 73.07 24.89 72.9"
    />
    <polygon
      fill={fillColor}
      points="25.97 73.07 27.22 73.07 27.4 72.9 27.22 72.72 25.74 72.72 25.57 72.89 25.57 75.43 25.74 75.59 27.22 75.59 27.4 75.42 27.22 75.24 25.97 75.24 25.95 75.22 25.95 74.34 25.97 74.32 27.01 74.32 27.2 74.14 27.01 73.97 25.97 73.97 25.95 73.94 25.95 73.1 25.97 73.07"
    />
    <polygon
      fill={fillColor}
      points="26.56 72.35 26.85 72.03 26.89 71.92 26.75 71.78 26.63 71.84 26.34 72.17 26.3 72.28 26.43 72.41 26.56 72.35"
    />
    <polygon
      fill={fillColor}
      points="18.73 78.29 18.85 78.16 18.73 78.03 17.88 78.03 17.86 78.01 17.86 77.49 17.88 77.47 18.59 77.47 18.71 77.34 18.59 77.21 17.88 77.21 17.86 77.19 17.86 76.7 17.88 76.68 18.73 76.68 18.85 76.55 18.73 76.42 17.7 76.42 17.58 76.53 17.58 78.17 17.7 78.29 18.73 78.29"
    />
    <polygon
      fill={fillColor}
      points="19.89 78.15 20.03 78.3 20.17 78.15 20.17 76.7 20.19 76.68 20.64 76.68 20.78 76.55 20.64 76.42 19.42 76.42 19.29 76.55 19.42 76.68 19.88 76.68 19.89 76.7 19.89 78.15"
    />
    <path
      fill={fillColor}
      d="M13.46,79.1h-.88l-.17,.17v2.52l.19,.2,.18-.2v-.95l.02-.02h.65c.58,0,.92-.35,.92-.86s-.35-.86-.92-.86Zm-.01,1.37h-.64l-.02-.03v-.96l.02-.03h.64c.35,0,.56,.19,.56,.51s-.21,.51-.56,.51Z"
    />
    <path
      fill={fillColor}
      d="M16.06,79.29l-.25-.21-.25,.21-.88,2.45-.02,.08,.18,.17,.18-.13,.19-.56h1.18l.2,.56,.18,.13,.18-.17-.02-.08-.87-2.45Zm-.72,1.67l.46-1.3h.01l.46,1.3h-.93Z"
    />
    <polygon
      fill={fillColor}
      points="17.27 79.1 17.09 79.28 17.27 79.45 17.94 79.45 17.96 79.47 17.96 81.79 18.15 81.99 18.33 81.79 18.33 79.47 18.36 79.45 19.02 79.45 19.21 79.28 19.02 79.1 17.27 79.1"
    />
    <path
      fill={fillColor}
      d="M21.87,79.93c0-.51-.35-.83-.91-.83h-.9l-.17,.17v2.52l.19,.2,.19-.2v-1.01l.02-.03h.64l.57,1.12,.18,.12,.18-.18-.03-.1-.52-1.01c.34-.11,.55-.39,.55-.77Zm-.91,.47h-.67l-.02-.03v-.9l.02-.03h.67c.34,0,.53,.18,.53,.48s-.2,.47-.53,.47Z"
    />
    <polygon
      fill={fillColor}
      points="22.75 79.28 22.75 81.79 22.94 81.99 23.13 81.79 23.13 79.28 22.94 79.08 22.75 79.28"
    />
    <polygon
      fill={fillColor}
      points="24.48 79.45 25.73 79.45 25.92 79.27 25.73 79.1 24.25 79.1 24.09 79.27 24.09 81.8 24.25 81.97 25.73 81.97 25.92 81.79 25.73 81.62 24.48 81.62 24.46 81.59 24.46 80.72 24.48 80.69 25.52 80.69 25.71 80.52 25.52 80.35 24.48 80.35 24.46 80.32 24.46 79.47 24.48 79.45"
    />
    <path
      fill={fillColor}
      d="M7.62,35.42h3.49c.28,0,.45-.16,.45-.43s-.17-.43-.45-.43h-3.66c-1.53,0-2.45,.84-2.45,2.26,0,.78,.26,1.39,.76,1.79h-.22c-.28,0-.45,.16-.45,.43s.17,.43,.45,.43h5.58c.28,0,.45-.16,.45-.43s-.17-.43-.45-.43h-3.62c-.98,0-1.67-.67-1.67-1.63,0-1.05,.59-1.56,1.8-1.56Z"
    />
    <path
      fill={fillColor}
      d="M5,28.7c0,1.09,.57,1.87,1.59,2.21,.52,.16,1.02,.23,1.72,.23s1.2-.06,1.73-.23c1.03-.34,1.59-1.13,1.59-2.21,0-.84-.25-1.44-.76-1.81h.23c.28,0,.45-.16,.45-.43s-.17-.43-.45-.43H2.87c-.28,0-.45,.16-.45,.43s.17,.43,.45,.43h2.89c-.51,.37-.76,.97-.76,1.81Zm1.86-1.66c.32-.1,.84-.15,1.46-.15s1.14,.05,1.47,.15c.68,.23,1.04,.76,1.04,1.54s-.38,1.3-1.07,1.53c-.37,.12-.76,.17-1.43,.17s-1.05-.05-1.42-.17c-.69-.23-1.07-.77-1.07-1.53s.36-1.31,1.04-1.54Z"
    />
    <path
      fill={fillColor}
      d="M6.67,24.66c.45,.14,.91,.2,1.65,.2s1.21-.06,1.64-.2c1.1-.36,1.68-1.21,1.68-2.45,0-.96-.36-1.76-1.01-2.28l-.28-.09c-.21,0-.38,.17-.38,.39l.15,.31c.48,.47,.68,.95,.68,1.63,0,.86-.4,1.44-1.17,1.7-.29,.09-.54,.12-1.07,.12v-3.88c0-.24-.16-.4-.4-.4-.62,0-1.1,.06-1.51,.2-1.06,.35-1.67,1.22-1.67,2.38s.61,2.03,1.67,2.37Zm.25-3.98c.25-.08,.52-.11,.87-.11v3.41c-.36,0-.62-.03-.87-.11-.72-.23-1.12-.8-1.12-1.59s.4-1.37,1.12-1.61Z"
    />
    <path
      fill={fillColor}
      d="M30.81,39.46v-.07l1.43-.86c.45-.27,.64-.57,.64-.98,0-.64-.41-1.05-.98-1.05-.19,0-.41,.07-.56,.15l-1.35,.72c-.52,.26-.9,.37-1.91,.37h-7.24c-4.39,0-6.38,2.06-6.38,6.49,0,2.44,.68,4.35,1.5,5.44,.23,.26,.53,.41,.83,.41,.56,0,.94-.37,.94-.94,0-.23-.08-.49-.22-.71-.6-1.01-1.13-2.55-1.13-4.09,0-3.53,1.65-4.66,4.62-4.66h1.28l.23,.22v4.58c0,4.32,1.8,6.79,5.33,6.79s5.29-2.66,5.29-6.12c0-2.82-.83-4.39-2.29-5.71Zm-3,9.79c-2.4,0-3.49-1.5-3.49-5.06v-4.28l.23-.22h2.66c2.47,0,3.98,2.07,3.98,5.14,0,2.89-1.16,4.43-3.38,4.43Z"
    />
    <path
      fill={fillColor}
      d="M30.55,21.83v-.04h1.24c.71,0,1.09-.41,1.09-1.01s-.38-1.01-1.09-1.01H15.76c-.71,0-1.09,.41-1.09,1.01s.38,1.01,1.09,1.01h10.4c3.08,0,4.99,2.1,4.99,4.8,0,3.11-1.8,4.61-5.37,4.61H15.76c-.71,0-1.09,.41-1.09,1.01s.38,1.01,1.09,1.01h10.51c4.35,0,6.83-2.25,6.83-6.19,0-2.51-.94-4.2-2.55-5.22Z"
    />
    <path
      fill={fillColor}
      d="M8.14,4.31h8.93v.04c-1.54,.86-2.63,2.44-2.63,5.37s1.61,5.22,4.43,6.15c1.46,.45,2.85,.64,4.88,.64s3.45-.19,4.92-.64c2.81-.93,4.43-3.11,4.43-6.15s-1.09-4.5-2.63-5.37v-.04h1.31c.71,0,1.09-.41,1.09-1.01s-.38-1.01-1.09-1.01H8.14c-.71,0-1.09,.42-1.09,1.01s.37,1.01,1.09,1.01Zm11.37,.45c.97-.3,2.48-.45,4.24-.45s3.3,.15,4.28,.45c2.1,.71,3.11,2.36,3.11,4.62s-1.2,3.9-3.23,4.58c-1.16,.37-2.36,.49-4.17,.49s-2.96-.11-4.13-.49c-2.03-.68-3.23-2.29-3.23-4.58s1.01-3.9,3.11-4.62Z"
    />
  </svg>
)

Vd.propsTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fillColor: PropTypes.string,
}

Vd.defaultProps = {
  width: "35",
  height: "105",
  fillColor: "#161615",
}

export default Vd
